import * as fromDatatype from '../datatype-library/index';

export interface app_login_change_email_mobile_number_process_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;

    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;

    subject_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    website_hdr_guid: fromDatatype.GuidDataFieldInterface;

    principal_guid_1: fromDatatype.GuidDataFieldInterface;
    principal_type_1: fromDatatype.VarcharDatatypeInterface;
    principal_id_1: fromDatatype.VarcharDatatypeInterface;
    verification_code_1: fromDatatype.VarcharDatatypeInterface;
    verification_code_created_date_1: fromDatatype.TimestampTzDatatypeInterface;
    verification_status_1: fromDatatype.VarcharDatatypeInterface;

    principal_guid_2: fromDatatype.GuidDataFieldInterface;
    principal_type_2: fromDatatype.VarcharDatatypeInterface;
    principal_id_2: fromDatatype.VarcharDatatypeInterface;
    verification_code_2: fromDatatype.VarcharDatatypeInterface;
    verification_code_created_date_2: fromDatatype.TimestampTzDatatypeInterface;
    verification_status_2: fromDatatype.VarcharDatatypeInterface;
    valid_date_end_2: fromDatatype.TimestampTzDatatypeInterface;

    change_email_mobile_number_key: fromDatatype.VarcharDatatypeInterface;
    change_email_mobile_number_status: fromDatatype.VarcharDatatypeInterface;
}

export class app_login_change_email_mobile_number_process_RowClass implements app_login_change_email_mobile_number_process_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;

    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;

    subject_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    website_hdr_guid: fromDatatype.GuidDataFieldInterface;

    principal_guid_1: fromDatatype.GuidDataFieldInterface;
    principal_type_1: fromDatatype.VarcharDatatypeInterface;
    principal_id_1: fromDatatype.VarcharDatatypeInterface;
    verification_code_1: fromDatatype.VarcharDatatypeInterface;
    verification_code_created_date_1: fromDatatype.TimestampTzDatatypeInterface;
    verification_status_1: fromDatatype.VarcharDatatypeInterface;

    principal_guid_2: fromDatatype.GuidDataFieldInterface;
    principal_type_2: fromDatatype.VarcharDatatypeInterface;
    principal_id_2: fromDatatype.VarcharDatatypeInterface;
    verification_code_2: fromDatatype.VarcharDatatypeInterface;
    verification_code_created_date_2: fromDatatype.TimestampTzDatatypeInterface;
    verification_status_2: fromDatatype.VarcharDatatypeInterface;
    valid_date_end_2: fromDatatype.TimestampTzDatatypeInterface;

    change_email_mobile_number_key: fromDatatype.VarcharDatatypeInterface;
    change_email_mobile_number_status: fromDatatype.VarcharDatatypeInterface;
}
